export function auctionDateTimeInputValue(timestamp: number): string {
  if (!Number.isFinite(timestamp)) return "";
  const value = new Date(timestamp);
  if (Number.isNaN(value.getTime())) return "";
  const local = new Date(timestamp - value.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 16);
}

export function parseAuctionDateTimeInput(value: string): number | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return null;
  const timestamp = new Date(value).getTime();
  if (!Number.isFinite(timestamp)) return null;
  return auctionDateTimeInputValue(timestamp) === value ? timestamp : null;
}
